import { useState, useEffect, useRef } from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import Pawandeep from '../../assets/student/Pawandeep_10th.jpg';
import Jasmeet from '../../assets/student/Jasmeet_10th.jpg';
import Pooja from '../../assets/student/Pooja_10th.jpg';
import Diksha from '../../assets/student/Diksha_10th.jpg';
import Piyush from '../../assets/student/Piyush_10th.jpg';
import Ruchika from '../../assets/student/Ruchika_10th.jpg';
import Palak from '../../assets/student/Palak_10th.jpg';
import Aryan from '../../assets/student/Aryan_10th.jpg';
import Ritik from '../../assets/student/Ritik_10th.jpg';
import Khushboo from '../../assets/student/Khushboo_10th.jpg';
import Navneet from '../../assets/student/Navneet_10th.jpg';
import Sukhjinder from '../../assets/student/Sukhjinder_10th.jpg';
import Jaspreet from '../../assets/student/Jaspreet_10th.jpg';
import Bhupender from '../../assets/student/Bhupender_10th.jpg';
import Manraj from '../../assets/student/Manraj_10th.jpg';
import Mansi from '../../assets/student/Mansi_10th.jpg';
import AliceCarousel from "react-alice-carousel";

function Success() {
  const courses = [
    {
      id: 1,
      title: "Pawandeep",
      Maths: "99",
      Science: "97",
      Batch: "2021-2022",
      image: Pawandeep,
    },
    {
      id: 2,
      title: "Jasmeet",
      Maths: "98",
      Science: "91",
      Batch: "2021-2022",
      image: Jasmeet,
    },
    {
      id: 3,
      title: "Pooja",
      Maths: "96",
      Science: "96",
      Batch: "2021-2022",
      image: Pooja,
    },
    {
      id: 4,
      title: "Mansi",
      Maths: "97",
      Science: "94",
      Batch: "2021-2022",
      image: Mansi,
    },
    {
      id: 5,
      title: "Diskha",
      Maths: "90",
      Science: "90",
      Batch: "2021-2022",
      image: Diksha,
    },
    {
      id: 6,
      title: "Piyush",
      Maths: "97",
      Science: "83",
      Batch: "2021-2022",
      image: Piyush,
    },
    {
      id: 7,
      title: "Ruchika",
      Maths: "98",
      Science: "94",
      Batch: "2021-2022",
      image: Ruchika,
    },
    {
      id: 8,
      title: "Palak",
      Maths: "93",
      Batch: "2021-2022",
      image: Palak,
    },
    {
      id: 9,
      title: "Aryan",
      Maths: "89",
      Batch: "2021-2022",
      image: Aryan,
    },
    {
      id: 10,
      title: "Ritik",
      Maths: "85",
      Batch: "2021-2022",
      image: Ritik,
    },
    {
      id: 11,
      title: "Khushboo",
      Maths: "83",
      Batch: "2021-2022",
      image: Khushboo,
    },
    {
      id: 12,
      title: "Navneet",
      Maths: "82",
      Batch: "2021-2022",
      image: Navneet,
    },
    {
      id: 13,
      title: "Sukhjinder",
      Maths: "77",
      Batch: "2021-2022",
      image: Sukhjinder,
    },
    {
      id: 14,
      title: "Jaspreet",
      Maths: "100",
      Batch: "2019-2020",
      image: Jaspreet,
    },
    {
      id: 15,
      title: "Manraj",
      Maths: "99",
      Batch: "2019-2020",
      image: Manraj,
    },
    {
      id: 16,
      title: "Bhupender",
      Maths: "99",
      Batch: "2019-2020",
      image: Bhupender,
    },
  ];

  const [isDesktop, setIsDesktop] = useState(false);
  const coursesRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const responsive = {
    0: { items: 1 },
    768: { items: 3 },
  };

  return (
    <div className="container my-5 mb-5 section-bg">
      <h5 className="orange-text text-center fw-bold p-3">Success Story</h5>
      <h2 className="blue-text text-center fw-bolder p-3">
        Have a look at awesome result of our students
      </h2>
      <div className="courses-carousel" ref={coursesRef}>
        <AliceCarousel
          mouseTracking
          items={courses.map((course) => (
            <div
              className="card mx-2 mb-5"
              style={{ height: "30rem" }}
              key={course.id}
            >
              <div className="d-flex flex-column justify-content-end">
                <img
                  src={course.image}
                  className="mx-auto mt-2 assests rounded-circle"
                  alt={`${course.title}`}
                  height="200"
                  width={200}
                />
                <h5 className="card-title fs-3 fw-bolder mx-auto orange-text mt-4">
                  {course.title}
                </h5>
                {course?.Maths && (
                  <p className="card-text fs-4 fw-bold mx-auto blue-text">
                    Maths - { + course.Maths + "/100"}
                  </p>
                )}
                {course?.Science && (
                  <p className="card-text fs-4 fw-bold mx-auto blue-text">
                    Science -  {course.Science + "/100"}
                  </p>
                )}
                <p className="card-text fs-4 fw-bold mx-auto blue-text">
                  Batch - {course.Batch}
                </p>
              </div>
            </div>
          ))}
          responsive={responsive}
          autoPlay
          autoPlayInterval={2000}
          animationDuration={500}
          disableDotsControls={!isDesktop}
          disableButtonsControls
          swipeDisabled={!isDesktop}
        />
      </div>
    </div>
  );
}

export default Success;
